import { FC } from 'react';
import { Input } from '@dynamika-shared/ui/Input/Input';
import { SearchSuffix } from '@dynamika-shared/ui/Input/SearchSuffix';
import { MultiFilter } from '@components/NestedFilter/MultiFilter';
import { Filter } from '@dynamika-shared/ui/icons';
import { Dropdown, MenuItemType } from '@dynamika-shared/ui/Dropdown/Dropdown';
import { PossibleSubscriptionFilters } from '@restore/clinicalTrialSubscription/subscriptionFilters.types';
import { AllFilters, SelectedFilters, StateFilterItem } from '@components/NestedFilter/types';
import { type MenuInfo } from 'rc-menu/lib/interface';

export type SubscriptionFiltersProps = {
  subFilters: Array<[PossibleSubscriptionFilters, StateFilterItem]>;
  allFilters: AllFilters<PossibleSubscriptionFilters, string>;
  selectedFilters: SelectedFilters<PossibleSubscriptionFilters>;
  filters: MenuItemType[];
  searchValue: string;
  onSearchChange: (value: string) => void;
  onToggleSelectedFilter: (params: { name: PossibleSubscriptionFilters; value: string }) => void;
  onToggleActiveFilter: (key: PossibleSubscriptionFilters) => void;
  onFilterClick: (item: MenuInfo) => void;
};

export const SubscriptionFilters: FC<SubscriptionFiltersProps> = ({
  subFilters,
  allFilters,
  selectedFilters,
  filters,
  searchValue,
  onSearchChange,
  onToggleSelectedFilter,
  onToggleActiveFilter,
  onFilterClick,
}) => {
  return (
    <div className='mb-4 flex w-full flex-row items-center gap-4'>
      <div className='ml-auto flex min-w-0 items-center gap-1'>
        <div className='flex min-w-0 items-center gap-1 overflow-x-auto'>
          {subFilters.map(([key, filter]) => (
            <div
              key={key}
              className='flex-shrink-0 [&_.truncate]:max-w-[30rem]'
            >
              <MultiFilter
                filterName={filter.label}
                filterKey={key}
                allItems={allFilters[key] || []}
                selectedValues={selectedFilters[key] || []}
                onToggleValue={value =>
                  onToggleSelectedFilter({ name: key, value })
                }
                onClose={() => onToggleActiveFilter(key)}
                active={filter.active}
                overlayClassName='w-[22.4rem]'
              />
            </div>
          ))}
        </div>
        <div
          role='button'
          className='hover:bg-waterLight flex h-[4rem] flex-shrink-0 cursor-pointer items-center rounded-md'
        >
          <Dropdown
            onClick={onFilterClick}
            items={filters}
            trigger={['click']}
            className='h-full p-1'
          >
            <div className='flex items-center justify-center gap-1'>
              <Filter height={20} width={20} />
              <div className='text-1424'>Filter</div>
            </div>
          </Dropdown>
        </div>
        <Input
          value={searchValue}
          onChange={e => {
            onSearchChange(e.target.value);
          }}
          classNameContainer=''
          className='!mt-0 h-[4.8rem] min-w-[32rem] !rounded-[3.2rem] px-2'
          placeholder='Search by name or email'
          type='search'
          autoComplete='off'
          suffix={
            <SearchSuffix
              disabled={!searchValue}
              action={() => {
                onSearchChange('');
              }}
            />
          }
        />
      </div>
    </div>
  );
};
